/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
	name: 'flexWorkforceView',
	initialState: {
		professionalsViewStateByManagementCompany: {},
		locationsViewStateByManagementCompany: {},
		activeTab: 'professionals'
	},
	reducers: {
		updateProfessionalsViewStateForManagementCompany: (state, action) => {
			const { managementCompanyId, ...partial } = action.payload;
			const existing = state.professionalsViewStateByManagementCompany[managementCompanyId] || {};
			state.professionalsViewStateByManagementCompany[managementCompanyId] = { ...existing, ...partial };
		},
		updateLocationsViewStateForManagementCompany: (state, action) => {
			const { managementCompanyId, ...partial } = action.payload;
			const existing = state.locationsViewStateByManagementCompany[managementCompanyId] || {};
			state.locationsViewStateByManagementCompany[managementCompanyId] = { ...existing, ...partial };
		},
		updateActiveTab: (state, action) => {
			state.activeTab = action.payload;
		}
	}
});

export const { updateProfessionalsViewStateForManagementCompany } = slice.actions;
export const { updateLocationsViewStateForManagementCompany } = slice.actions;
export const { updateActiveTab } = slice.actions;

export const viewStateForWorkforceProfessionals = (managementCompanyId) => (state) =>
	state.flexWorkforceView.professionalsViewStateByManagementCompany[managementCompanyId];
export const viewStateForWorkforceLocations = (managementCompanyId) => (state) =>
	state.flexWorkforceView.locationsViewStateByManagementCompany[managementCompanyId];

export const activeTab = (state) => state.flexWorkforceView.activeTab;

export default slice.reducer;
